var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



//////////////////
// WEBPACK FOOTER
// /usr/src/app/~/enquire.js/src/index.js
// module id = 170
// module chunks = 35783957827783 156715226241819